import { differenceInMinutes } from 'date-fns'

export function getProximoHorarioIndisponivel(
  horarioInicial: Date | undefined,
  horariosAgenda: { horario: Date; duracao: number; isOcupado: boolean }[] | undefined
): Date | undefined {
  return (
    horarioInicial &&
    horariosAgenda?.find(
      (h, i, arr) =>
        Number(h.horario) > Number(horarioInicial) &&
        (h.isOcupado || (i > 0 && differenceInMinutes(h.horario, arr[i - 1].horario) > arr[i - 1].duracao))
    )?.horario
  )
}
